import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { isEmpty } from '@sama/micro-dash';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { FeatureFlagService } from '../../shared/misc-services/feature-flag.service';
import { SamplingWorkspaceStore } from '../state/sampling-workspace-store';

@Component({
  selector: 'h3-sampling-workspace-footer',
  templateUrl: './sampling-workspace-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SamplingWorkspaceFooterComponent {
  protected readonly samplingWorkspaceStore = inject(SamplingWorkspaceStore);
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);
  showRejectionHistory$ = this.buildShowRejectionHistory$();
  enableNewSamplingNav = inject(FeatureFlagService).hasFlag('new-sampling-nav');

  private buildShowRejectionHistory$() {
    return this.taskWorkspaceStore('task')('_extras')(
      'rejection_history',
    ).$.pipe(map((history) => !isEmpty(history)));
  }
}
